import { Outlet } from "react-router";
import { Footer } from "./Footer";
import { motion } from "motion/react";

export function LegalLayout() {
    return (
        <div className="min-h-screen flex flex-col font-sans relative" style={{ fontFamily: "'Inter', sans-serif" }}>
            {/* 
        This layout intentionally omits the <Navbar /> 
        per the requirement for the Privacy/Terms/Sitemap pages.
      */}
            <main className="flex-grow pt-10 pb-20 bg-gray-50">
                <Outlet />
            </main>

            <Footer />
        </div>
    );
}
